import React from 'react'

const HeroPageLink = ({ hero }) => {
    const url = `https://playoverwatch.com/en-us/heroes/${hero.path}`
    return (
        <a href={url} target="_blank" rel="noopener noreferrer"><button>Learn More</button></a>
    )
}

export default HeroPageLink
